import { jsx as e } from "react/jsx-runtime";
import { useMemo as y, useCallback as i } from "react";
import { Button as s } from "../../Button/index.js";
import "../ProductTileSkeleton.js";
import { QuantityPicker as o } from "../../QuantityPicker/index.js";
import { IconAddToCart as p } from "../../Icon/icons/AddToCart.js";
const W = ({ action: d = "addToCart", attributes: l, onAction: a, productName: u, quantityInCart: c = 0, sku: r }) => {
  const t = y(() => {
    switch (d) {
      case "adding":
        return "Adding";
      case "addToCart":
      case "soldOut":
        return "Add to Cart";
      case "added":
        return "Added";
      case "updating":
        return "Updating";
      case "removing":
        return "Removing";
      case "chatToAnExpert":
        return "Chat to an Expert";
      case "loading":
      default:
        return "Loading";
    }
  }, [d]), h = i(async () => {
    await (a == null ? void 0 : a({
      action: "addToCart",
      payload: {
        sku: r
      }
    }));
  }, [a, r]), m = i(async () => {
    await (a == null ? void 0 : a({
      action: "removeFromCart",
      payload: {
        sku: r
      }
    }));
  }, [r, a]), n = i(async () => {
    await (a == null ? void 0 : a({
      action: "decreaseQuantity",
      payload: {
        sku: r
      }
    }));
  }, [a, r]), f = i(async () => {
    await (a == null ? void 0 : a({
      action: "increaseQuantity",
      payload: {
        sku: r
      }
    }));
  }, [a, r]), C = i(async () => {
    await (a == null ? void 0 : a({
      action: "chatToAnExpert",
      payload: {
        productName: u
      }
    }));
  }, [a, u]);
  return a ? ["adding", "loading", "removing", "updating"].includes(d) ? e(s, { variant: "shop", size: "md", disabled: !0, loading: !0, loaderProps: {
    color: "black"
  }, fullWidth: !0, children: t }) : d === "quantityPicker" ? e(o, { onRemoveClick: m, onDecreaseClick: n, onIncreaseClick: f, quantity: c, attributes: l }) : d === "chatToAnExpert" ? e(s, { onClick: C, variant: "secondary", fullWidth: !0, ...l == null ? void 0 : l["actions-chat-to-an-expert"], children: t }) : d === "soldOut" ? e(s, { variant: "shop", leftIcon: e(p, { size: 20 }), disabled: !0, fullWidth: !0, children: t }) : d === "added" ? e(s, { variant: "shop", disabled: !0, fullWidth: !0, children: t }) : e(s, { onClick: h, variant: "shop", leftIcon: e(p, { size: 20 }), fullWidth: !0, ...l == null ? void 0 : l["actions-add-to-cart"], children: t }) : null;
};
export {
  W as Actions
};
